var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "page", class: ["page", "index-page"], attrs: { id: "page" } },
    [
      _c(
        "div",
        { staticClass: "datepicker-content as-flex main-center cross-center" },
        [
          _c(
            "div",
            {
              staticClass:
                "arrow last-week-arrow as-flex main-center cross-center",
              on: {
                click: function ($event) {
                  return _vm.changeweek(-1)
                },
              },
            },
            [_c("i", { staticClass: "el-icon-arrow-left" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "datepicker-container" },
            [
              _c("el-cascader", {
                staticClass: "datepicker",
                attrs: {
                  placeholder: "请选择周期",
                  options: _vm.dateOptions,
                  "show-all-levels": false,
                },
                on: { change: _vm.handleDateChange },
                model: {
                  value: _vm.dateOptionsSelected,
                  callback: function ($$v) {
                    _vm.dateOptionsSelected = $$v
                  },
                  expression: "dateOptionsSelected",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "arrow next-week-arrow as-flex main-center cross-center",
              on: {
                click: function ($event) {
                  return _vm.changeweek(1)
                },
              },
            },
            [_c("i", { staticClass: "el-icon-arrow-right" })]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "chart-content" }, [
        _c(
          "div",
          { staticClass: "top-function-bar as-flex main-between cross-center" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right-function as-flex main-end cross-end" },
              [
                _c(
                  "div",
                  { staticClass: "crowd-picker as-flex main-end cross-center" },
                  [
                    _c("crowdpicker", {
                      attrs: {
                        options: _vm.crowd_config,
                        current_crowd: _vm.current_crowd,
                      },
                      on: { crowdUpdate: _vm.crowdUpdate },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "multi-compaire f-2 as-flex main-end cross-center",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "multi-compaire-btn",
                        on: { click: _vm.multiCompaire },
                      },
                      [_vm._v("详细对比")]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "chart-container as-flex main-between cross-center" },
          [
            _c(
              "div",
              { staticClass: "chart-box" },
              [
                _c(
                  "div",
                  { staticClass: "chart-desc as-flex main-start cross-center" },
                  [
                    _c("span", [_vm._v("认知度")]),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content:
                            "在调研周期节点，'听说过'此影片的样本中对此影片类型感知的比例",
                          placement: "top-start",
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "question-tip-icon icon-2",
                          attrs: {
                            tabindex: "0",
                            src: require("../assets/images/question@3x.png"),
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "f-2 fc-gray-2" }, [
                      _vm._v(_vm._s(_vm.offsetMapping[_vm.latestOffset])),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("indexChart", {
                  staticClass: "index-chart",
                  attrs: {
                    indicator: "awareness",
                    offset: _vm.latestOffset,
                    update_date: _vm.update_date,
                    config: _vm.chartData,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chart-box" },
              [
                _c(
                  "div",
                  { staticClass: "chart-desc as-flex main-start cross-center" },
                  [
                    _c("span", [_vm._v("首选度")]),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content:
                            "在调研周期节点，对此影片'非常感兴趣和比较感兴趣'的样本中'下次观影首先选择'此影片的比例。",
                          placement: "top-start",
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "question-tip-icon icon-2",
                          attrs: {
                            tabindex: "0",
                            src: require("../assets/images/question@3x.png"),
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "f-2 fc-gray-2" }, [
                      _vm._v(_vm._s(_vm.offsetMapping[_vm.latestOffset])),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("indexChart", {
                  staticClass: "index-chart",
                  attrs: {
                    indicator: "primary",
                    offset: _vm.latestOffset,
                    update_date: _vm.update_date,
                    config: _vm.chartData,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "list-content" }, [
        _c(
          "div",
          { staticClass: "list-list" },
          [
            _vm._l(_vm.movieList, function (item) {
              return [
                item.id
                  ? _c(
                      "div",
                      {
                        key: "movie_" + item.id,
                        staticClass: "movie-box-container",
                        on: {
                          click: function ($event) {
                            item.result.is_tracking
                              ? _vm.setMainMovie(item.id)
                              : _vm.commitRequirement(item)
                          },
                        },
                      },
                      [
                        _c("movieBox", {
                          attrs: {
                            movieInfo: item,
                            isLatest: _vm.latestOffset === item.result.offset,
                            isTracking: item.result.is_tracking,
                            type: "single",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left-title" }, [
      _c("span", { staticClass: "f-4 fc-gray" }, [_vm._v("调研数据")]),
      _vm._v(" "),
      _c("span", { staticClass: "f-2 fc-gray-2" }, [_vm._v("每周四更新")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "list-title as-flex main-start cross-center f-2 fc-gray-2",
      },
      [
        _c(
          "div",
          { staticClass: "list-title-movie as-flex main-center cross-center" },
          [_c("span", [_vm._v("影片")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "list-title-awareness as-flex main-center cross-center",
          },
          [_c("span", [_vm._v("认知")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "list-title-primary as-flex main-center cross-center",
          },
          [_c("span", [_vm._v("首选")])]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }